import { i18n } from '../../i18n';




export const filterColumnsHash = {
  screen_name_cont: {
    label: i18n.t('user.screenName'),
    renderCell: {
      component: 'input'
    }
  },
}

export const columnsHash = {
  id: {
    label: i18n.t('user.id'),
    width: 80,
  },
  screen_name: {
    label: i18n.t('user.screenName'),
  },
  created_at: {
    label: i18n.t('user.createdAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  last_access_at: {
    label: i18n.t('user.lastAccessAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  updated_at: {
    label: i18n.t('user.updatedAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  avatar: {
    label: i18n.t('user.avatar'),
    width: 120,
    renderCell: 'storageAttachment',
  },
}

export const formColumnsHash = {

}
